<template>
  <div style="height: 100%;width: 100%">
    <router-view></router-view>
  </div>
</template>
